<template>
  <div>
    <v-row align="center" justify="center" no-gutters>
      <v-col>
        <h2 class="titulo">Materias disponibles</h2>
      </v-col>
      <v-col md="auto" class="mr-4">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information</v-icon>
          </template>
          <span
            >Lista de Materias disponibles en el sistema para agregar a un
            curso/agrupamiento.</span
          >
        </v-tooltip>
      </v-col>
      <v-dialog v-model="nuevaMateriaDialog" width="30%">
        <v-card>
          <v-card-title class="grey lighten-4 py-4 title"
            >Nueva Materia</v-card-title
          >
          <v-row align="center" justify="center" no-gutters>
            <v-col class="pt-4 pr-4 pb-0 pl-4">
              <v-text-field
                v-model="nombreNuevaMateria"
                label="Solo"
                placeholder="Nombre Materia"
                solo
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row align-center justify="center" v-if="msj_error" no-gutters>
            <v-col class="text-center">
              <label class="msj">{{ texto_msj }}</label>
            </v-col>
          </v-row>
          <v-row align-center justify="center" no-gutters>
            <v-col class="btn_dialog text-center">
              <v-btn color="primary" @click="guardarMateria"
                >Guardar Materia</v-btn
              >
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row align-center justify="end">
      <v-col shrink class="nueva_materia_btn">
        <v-btn
          color="success"
          @click="
            nombreNuevaMateria = '';
            msj_error = false;
            nuevaMateriaDialog = !nuevaMateriaDialog;
          "
          >Añadir Nueva Materia</v-btn
        >
      </v-col>
    </v-row>
    <template v-if="materias_disponibles.length > 0">
      <template v-for="materia in materias_disponibles">
        <v-row
          align="center"
          justify="start"
          :key="materia.idmateria"
          class="materias"
          no-gutters
        >
          <v-col class="nombre_materia">{{ mayus(materia.materia) }}</v-col>
          <v-col cols="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  class="agregar_materia_icono"
                  v-on="on"
                  @click="agregarMateriaCurso(materia.idmateria)"
                  >mdi-plus-circle</v-icon
                >
              </template>
              <span>Agregar Materia</span>
            </v-tooltip>
          </v-col>
          <!--<v-col xs2></v-col>-->
        </v-row>
      </template>
    </template>
    <template v-else>Error: {{ this.materias_disponibles.length }}</template>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
export default {
  data() {
    return {
      nuevaMateriaDialog: false,
      texto_msj: "La matería ya esta en el Sistema",
      msj_error: false,
      nombreNuevaMateria: ""
    };
  },
  components: {},
  props: ["idAgrupamiento", "materias_disponibles"],
  mounted: function() {},
  methods: {
    mayus(str) {
      let strAux = API.ucFirst(str);
      return strAux;
    },
    agregarMateriaCurso(idMateria) {
      //console.log("agregarMateriaCurso");

      let params = "idAgrupamiento=" + this.idAgrupamiento;
      params += "&idMateria=" + idMateria;

      let resultado = API.enviar("get", "agregarMateriaCurso", params);

      resultado
        .then(result => {
          if (result.data.msj == "ok") {
            this.$emit(
              "curriculaNuevaMateria:recargarDatos",
              this.idAgrupamiento
            );
          }
        })
        .catch(() => {
          //this.$emit("curriculaNuevaMateria:mostrarOcultarPreload");
        });
    },
    guardarMateria() {
      let materia = this.nombreNuevaMateria;
      let params = "materia=" + materia;

      let resultado = API.enviar("get", "guardarMateria", params);
      //console.log(this.nombreNuevaMateria);
      resultado
        .then(result => {
          if (result.data.msj == "ok") {
            this.nuevaMateriaDialog = false;
            this.$emit(
              "curriculaNuevaMateria:recargarDatos",
              this.idAgrupamiento
            );
          } else {
            this.msj_error = true;
            //console.log(result.data.msj);
          }
        })
        .catch(() => {
          //this.$emit("curriculaNuevaMateria:mostrarOcultarPreload");
        });
    }
  }
};
</script>

<style scoped>
/*.titulo {
  border-bottom: solid 1px #ccc;
}*/

.nombre_materia {
  padding: 0 10px 0 10px;
  text-align: right;
}
.agregar_materia_icono {
  color: green;
}

.nueva_materia_btn {
  padding-bottom: 20px;
}

.btn_dialog {
  padding: 15px 0px;
}

.msj {
  color: red;
  font-weight: bold;
}
</style>